import { render, staticRenderFns } from "./VuesticSwitch.vue?vue&type=template&id=66438f29"
import script from "./VuesticSwitch.vue?vue&type=script&lang=js"
export * from "./VuesticSwitch.vue?vue&type=script&lang=js"
import style0 from "./VuesticSwitch.vue?vue&type=style&index=0&id=66438f29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports